var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Pointer",on:{"click":_vm.onClick}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"arrowRight"})])}
var staticRenderFns = []

export { render, staticRenderFns }